<div class="tw-flex tw-flex-col tw-h-full">
  <p class="tw-font-strong tw-mb-1.5">@if (label) { {{ label }}}@else { <ng-content select="[title]"></ng-content>}</p>
  <p>@if(text){{{ text }}} @else { <ng-content select="[text]"></ng-content>}</p>
</div>
